import { Component, OnInit, OnDestroy } from '@angular/core';
import { NoteService } from 'src/app/services/notes/note.service';
import { GeneralService } from 'src/app/services/general.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { GeneralTaskService } from 'src/app/services/task/general-task.service';
import { noWhitespaceValidator } from 'src/app/utils/no-whitespace.validator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NoteFeedService } from 'src/app/services/notes/notes-feeds.service';

@Component({
  selector: 'app-note-feeds',
  templateUrl: './note-feeds.component.html',
  styleUrls: ['./note-feeds.component.css']
})
export class NoteFeedsComponent implements OnInit, OnDestroy {

  private unsubscribe = new Subject<any>();
  spinnerType: string;
  spinnerStyle: any = {};
  setSpinnerStatus: string;
  showSpinner: boolean = true;
  showSmallSpinner: boolean = false;
  smallSpinnerStyle: any = { 'margin-left': '' };
  isLoadingMore: boolean = false;
  pageContext;
  userNotes: Array<any> = [];
  loadedUserNotes: any = [];
  note: any = {};
  id: any;
  pageNo: number = 0;
  userID;
  showLoading: boolean = false;
  showNoteLoading: boolean = false;
  supervisorUsers: any;
  supervisor: any;
  subordinate: any = [];

  constructor(
    private noteSrv: NoteService,
    private generalSrv: GeneralService,
    private generalTaskSrv: GeneralTaskService,
    private emailService: EmailService,
    private noteFeedSrv: NoteFeedService,
    store: Store<AppState>,
  ) {
    this.spinnerType = "jsBin";
    this.setSpinnerStatus = "";
    this.spinnerStyle = { top: '25%' };
    store.select("userInfo").subscribe(info => {
      this.userID = info.user.id;
      this.supervisor = info.supervisor;
    });
  }

  editNoteForm = new FormGroup({
    content: new FormControl('', [Validators.required, noWhitespaceValidator]),
    noteID: new FormControl(''),
    assigneeID: new FormControl(''),
    clientID: new FormControl(''),
    clientName: new FormControl(''),
    creatorName: new FormControl(''),
    dealCode: new FormControl(''),
    dealName: new FormControl(''),
    teamID: new FormControl(''),
    createdDate: new FormControl(''),
  })

  deleteNoteForm = new FormGroup({
    noteID: new FormControl('')
  })

  ngOnInit() {
    this.pageContext = '';
    this.userNotes = [];
    this.loadedUserNotes = [];
    this.getPageContext();
    this.noteSrv.refreshNeeded$
      .subscribe(() => {
        this.pageNo -= 1;
        this.getPageContext();
      })
  }

  getPageContext() {
    this.isLoadingMore = true;
    this.emailService.email_context.subscribe((context: any) => {
      if (!this.generalSrv.checkIfObjectIsEmpty(context)) {
        this.pageContext = context.name;
        this.getData(context);
      }
    });
  }

  getData(context) {
    // console.log('context', context)
    let pageNo = 0;
    pageNo += 1;
    this.pageNo += 1;
    switch (context.name) {
      case 'lead':
        this.noteFeedSrv.notesFeeds(context.data.id, 4, this.pageNo)
          .subscribe((userNotes: any) => {
            const notes = [...this.userNotes, ...userNotes].sort((a, b) => b.date - a.date);
            this.userNotes = this.processNotes(notes);
          })
        break;
      case 'dashboard':
        if (this.supervisor) {
          this.generalTaskSrv.getUsersBySupervisor()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(supervisorAttachedUsers => {
              let supervisorUsers: any = supervisorAttachedUsers;
              let subordinate = supervisorUsers.map(member => member.id);
              this.noteFeedSrv.notesFeeds(subordinate, 1, this.pageNo)
                .subscribe((userNotes: any) => {
                  const notes = [...this.userNotes, ...userNotes].sort((a, b) => b.date - a.date);
                  this.userNotes = this.processNotes(notes);
                  this.loadedUserNotes = userNotes
                })
            })
        } else {
          this.noteFeedSrv.notesFeeds(context.data.id, 1, this.pageNo)
            .subscribe((userNotes: any) => {
              const notes = [...this.userNotes, ...userNotes].sort((a, b) => b.date - a.date);
              this.userNotes = this.processNotes(notes);
            })
        }
        break;

      case 'deal':
        this.noteFeedSrv.notesFeeds(context.data.id, 3, pageNo)
          .subscribe((userNotes: any) => {
            this.userNotes = userNotes;
          })
        break;

      case 'company':
        // const companyData = [context.company.clientId,context.company.customLeadId?context.company.customLeadId:'']
        //   const joinedData = companyData.join()
        this.noteFeedSrv.notesFeeds( context.company.clientId, 4, pageNo)
          .subscribe((userNotes: any) => {
            this.userNotes = userNotes;
          })
        break;

      case 'contact':
          // const data = [context.contact.customLeadId?context.contact.customLeadId:'',context.contact.clientId]
          // const joined = data.join()
        this.noteFeedSrv.notesFeeds(context.contact.clientId, 4, pageNo)
          .subscribe((userNotes: any) => {
            this.userNotes = userNotes;
          })
        break;

        // this.noteFeedSrv.notesFeeds(context.data.id, 4, this.pageNo)
        // .subscribe((userNotes: any) => {
        //   this.userNotes = this.processNotes([...this.userNotes, ...userNotes]);

      case 'salesPerson':
        this.noteFeedSrv.notesFeeds(context.data.id, 1, pageNo)
          .subscribe((userNotes: any) => {         
                this.userNotes = userNotes;
          })
        break;

      case 'teams':
        this.noteFeedSrv.notesFeeds(context.data.id, 2, pageNo)
          .subscribe((userNotes: any) => {
            this.userNotes = userNotes;
          })
        break;
      default:
        break;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  processNotes(notes) {
    const processedIds = {};
    return notes.reduce((sac, log) => {
      if (processedIds[log.id]) return sac;
      processedIds[log.id] = true;
      this.isLoadingMore = false;
      return [...sac, log];
    }, []);
  }

}
